import { AudioManager } from './audioManage'
export const useAudio = () => {
  const audioManager = AudioManager.getInstance()
  // 播放音乐
  const play = audioManager.playAudio.bind(audioManager)
  const stop = audioManager.stopAudio.bind(audioManager)
  const pause = audioManager.pauseAudio.bind(audioManager)
  const resume = audioManager.resumeAudio.bind(audioManager)
  const destroy = audioManager.destroyAudio.bind(audioManager)
  return {
    play,
    stop,
    pause,
    resume,
    destroy
  }
}
